export default __webpack_public_path__ + "static/media/MLT.99feb0eb.svg";